var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircledRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.908,
    height: 14.908,
    viewBox: "0 0 14.908 14.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60625",
    "data-name": "Group 60625",
    transform: "translate(4.482 -1032.309)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1472",
    "data-name": "Ellipse 1472",
    cx: 7.454,
    cy: 7.454,
    r: 7.454,
    transform: "translate(-4.482 1032.309)",
    fill: "#227c9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159888",
    "data-name": "Path 159888",
    d: "M5.426,3,5,3.417,7.776,6.244,5,9.074l.426.417L8.613,6.245Z",
    transform: "translate(-3.553 1033.517)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledRight);
export default __webpack_public_path__ + "static/media/circledRight.c11dc2f5f340b93db422638788d0a1a4.svg";
export { ForwardRef as ReactComponent };